import type * as React from 'react';

/** Blok jednoho stavu komponenty na strance galerie. */
export function StateSection({
  title,
  description,
  children,
}: {
  readonly title: string;
  readonly description?: string;
  readonly children: React.ReactNode;
}): React.JSX.Element {
  return (
    <section className="gal-state">
      <h2 className="gal-state__title">{title}</h2>
      {description ? <p className="gal-state__description">{description}</p> : null}
      <div className="gal-state__demo">{children}</div>
    </section>
  );
}

export function PageIntro({ title, lead }: { readonly title: string; readonly lead: string }): React.JSX.Element {
  return (
    <header className="gal-intro">
      <h1 className="gal-intro__title">{title}</h1>
      <p className="gal-intro__lead">{lead}</p>
    </header>
  );
}
